<template>
    <v-container fluid>   
      <LeftMenu/> 
        <v-layout row wrap>   
          <v-flex xs12>
            <Progress :show="this.showProgress" />
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs11>
            <v-data-table
              :headers="headers"
              :items="expensesFormatted"
              :items-per-page="50"
              item-key="id"
              sort-by="expenseDate"
              :sort-desc=true
              class="elevation-1"
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Expenses</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-flex xs2 class="pr-3">
                    <DatePicker picker-label="" :date-value="expensesStartDate" @dateSelected="expensesStartDate=$event" />
                  </v-flex>
                  <v-flex xs2 class="pr-3"> 
                    <DatePicker picker-label="" :date-value="expensesEndDate" @dateSelected="expensesEndDate=$event" />                  
                  </v-flex> 
                   <v-flex xs5>
                    <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">New Expense</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>                                                         
                            <v-flex xs12 sm6 md4>                              
                              <DatePicker picker-label="Expense Date" :date-value="editedItem.expenseDate" @dateSelected="editedItem.expenseDate=$event" /> 
                            </v-flex> 
                            <v-flex xs12 sm6 md8>
                              <v-combobox
                                :items="bankAccountList"
                                label="Select Bank Account"
                                v-model="editedItem.bankAccount"
                                item-text="accountName"
                                single-line
                                return-object
                                v-on:change="bankAccountSelected"
                              ></v-combobox>
                            </v-flex>  
                            <v-flex xs12 sm6 md4>
                              <v-currency-field :key="editedItem.id" v-model="editedItem.amount" label="Amount"></v-currency-field>
                            </v-flex>
                             
                            <v-flex xs12 sm6 md4>
                              <v-combobox
                                disabled
                                :items="currencyListWithText"
                                label="Select Currency"
                                v-model="editedItem.currency"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex>  
                            <v-flex xs12 sm6 md4/>
                            <v-flex xs12 sm6 md4>
                              <v-combobox
                                :items="masterCategoryList"
                                label="Select Master Category"
                                v-model="selectedMasterCategory"
                                item-text=""
                                single-line
                                return-object
                                v-on:change="getCategoriesByMaster"
                              ></v-combobox>
                            </v-flex> 
                            <v-flex xs12 sm6 md4>
                              <v-combobox
                                :items="categoryList"
                                label="Select Category"
                                v-model="editedItem.category"
                                item-text="text"
                                single-line
                                return-object
                                v-on:change="categorySelected"
                              ></v-combobox>
                            </v-flex> 
                              
                            <v-flex xs12 sm6 md4 >                             
                               <v-combobox
                                v-if="editedItem.category.personnelRelated"
                                :items="personnels"
                                label="Select Personnel"
                                v-model="editedItem.personnel"
                                item-text="name"
                                single-line
                                return-object
                              >
                                <template slot="selection" slot-scope="data">
                                  {{ data.item.name }}  {{ data.item.surname }}
                                </template>
                                <template slot="item" slot-scope="data">
                                  {{ data.item.name }}  {{ data.item.surname }}
                                </template>
                              </v-combobox>
                            </v-flex>     
                            <v-flex xs12 sm6 md12 >                             
                               <v-combobox
                                :items="budgetAssumptions"
                                label="Select Budget Assumption"
                                v-model="editedItem.assumption"
                                item-text="explanation"
                                single-line
                                return-object
                              >
                                <template slot="selection" slot-scope="data">
                                  {{ data.item.id }} - {{ data.item.period.text }} - {{ data.item.amount }} {{ data.item.currency.code }} {{ data.item.title }} - {{ data.item.explanation }}  
                                </template>
                                <template slot="item" slot-scope="data">
                                  {{ data.item.id }} - {{ data.item.period.text }} - {{ data.item.amount }} {{ data.item.currency.code }} {{ data.item.title }} - {{ data.item.explanation }}  
                                </template>
                              </v-combobox>
                            </v-flex>                   
                            <v-flex xs12 sm6 md12>
                              <v-textarea v-model="editedItem.explanation"  :outlined="true"
                              :auto-grow="true" :clearable="true"
                              label="Explanation"></v-textarea>
                            </v-flex>                                                                                                                                                                       
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                <v-layout row wrap>
                  <v-flex xs1/>  
                  <v-flex xs1 align-self-center="true">  
                    <Xlsx filename="expenses" :items="xlsxItems"  :headers="xlsxHeaders" />                                      
                  </v-flex> 
                  <v-flex xs1 align-self-center="true">
                  Total:  
                  </v-flex>
                  <v-flex xs2 align-self-center="true">
                    {{ totalExpenseUSDAmountFormatted}} USD                   
                  </v-flex>  
                  <v-flex xs1 align-self-center="true">
                  Total:  
                  </v-flex>
                  <v-flex xs2 align-self-center="true">
                    {{ totalExpenseAmountFormatted}} TRY                   
                  </v-flex>     
                  <v-flex xs2 align-self-baseline="center">
                    <v-combobox
                      :items="filterCategoryList"
                      label="Filter By Category"
                      v-model="selectedCategoriesFilter"
                      item-text="text"
                      multiple
                      chips
                      return-object
                    ></v-combobox> 
                  </v-flex>
                  <v-flex xs1 align-self-baseline="center">
                    <v-icon                  
                      @click="filterExpenses">
                      mdi-refresh
                    </v-icon>
                  </v-flex> 
                </v-layout>  
              </template> 
              <template v-slot:body.append>                    
              </template>             
              <template v-slot:item.expensesActions="{ item }">            
                <v-icon                  
                  @click="duplicateItem(item)">
                  mdi-content-duplicate
                </v-icon>
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
    </v-container>
</template>


<script>
import LeftMenu from '../components/LeftMenu';
import DatePicker from '../components/DatePicker';
import Progress from '../components/Progress';
import Xlsx from '../components/Xlsx';
import formatPrice from '../helpers/formatter';
import formatToDouble from '../helpers/formatToDouble';
import getCurrentDate from '../helpers/getCurrentDate';
import getCurrentMonthStart from '../helpers/getCurrentMonthStart';

const API_URL = 'expenses';
const CURRENCIES_API_URL = 'definitions/currencies';
const BANK_ACCOUNTS_API_URL = 'definitions/bankAccounts';
const CATEGORIES_API_URL = 'definitions/expenseCategories/masterCategory';
const ASSUMPTIONS_API_URL = 'budgetAssumptions/filter/expenseCategory';
const ALL_CATEGORIES_API_URL = 'definitions/expenseCategories';
const MASTER_CATEGORIES_API_URL = 'definitions/expenseCategories/masterCategories';
const PERSONNEL_API_URL = 'definitions/personnelReduced';
export default {
    components:{
      LeftMenu,
      DatePicker,
      Progress,
      Xlsx
    },
    data () {
    return {
      dialog: false,
      search: '',
      showProgress : false,
      expensesStartDate: '',
      expensesEndDate: '', 
      totalExpenseAmount: 0,
      totalExpenseAmountUSD: 0,
      categoryList: [],
      masterCategoryList: [],
      allCategoryList: [],
      selectedCategoriesFilter: [],
      currencyList: [],
      personnels: [],
      budgetAssumptions: [],
      bankAccountList: [],
      selectedMasterCategory: '',
      expenses: [],
      editedIndex: -1,
      editedItem: {
        category: '',
        amount: 0,
      },
      defaultItem: {
        category: '',
        amount: 0, 
      },
      xlsxHeaders: {
        id : 'Expense Id' ,
        expenseDate : 'Expense Date' ,
        category : 'Category'  ,
        explanation : 'Explanation' ,       
        amount : 'Amount' ,        
        currency : 'Currency',
        account : 'Account' 
      }
    }
  },
  computed: {
    headers () {
      return [
        {text: 'Expense Id',align: 'left',sortable: true,value: 'id'},
        { text: 'Expense Date', value: 'expenseDate' },
        {text: 'Assumption',align: 'left',sortable: true,value: 'assumption.id'},
        {text: 'Explanation',align: 'left',sortable: true,value: 'explanation'},
        { text: 'Category',  value: 'category.text'  },        
        { text: 'Amount', align: 'right', sortable: true, value: 'amountFormatted' , sort: (a, b) =>  formatToDouble(a) - formatToDouble(b) },      
        { text: 'Currency', value: 'currency.code' },
        { text: 'Account', value: 'bankAccount.accountName' },
        { text: 'Actions', value: 'expensesActions', sortable: false },
      ]
    },
    xlsxItems(){
      return this.expenses.map((item) => {
        return {
          id: item.id,
          expenseDate: item.expenseDate,
          category: item.category.text,
          explanation: item.explanation,
          amount: formatPrice(item.amount) ,
          currency: item.currency.code ,
          account: item.bankAccount.accountName                   
        }
      });
    },
    filterCategoryList(){
      let newList = this.allCategoryList;
      newList.push({id:0,text:""});
      return newList;
    },
    totalExpenseUSDAmountFormatted(){
      return formatPrice(this.totalExpenseAmountUSD);
    },
    totalExpenseAmountFormatted(){
      return formatPrice(this.totalExpenseAmount);
    },
    expensesFormatted(){
      return this.expenses.map((item) => {
        item.amountFormatted = formatPrice(item.amount);
        return item;  
      })
    },
    currencyListWithText(){
      return this.currencyList.map((item) => {
        return {
          id: item.id,
          code: item.code,
          text: item.code+' - '+item.text          
        };
      })
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Expense' : 'Edit Expense'
    },
  },
  created() {        
    this.showProgress = true;
    this.fillIntervalDates();
    this.getMasterCategories();
    this.getAllCategories();
    this.getCurrencies();
    this.getBankAccounts();
    this.getPersonnels();
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    expensesStartDate (val){
      this.expensesStartDate = val;
      if(val && this.expensesEndDate){      
        this.filterExpenses();
      }
    },
    expensesEndDate(val){
      this.expensesEndDate = val;
      if(val && this.expensesStartDate){        
        this.filterExpenses();
      }
    }
  },
  methods: {
    filterExpenses (){
      var selectedFilters = [];
      if(this.selectedCategoriesFilter && this.expensesStartDate && this.expensesEndDate){  
        this.showProgress = true;       
        selectedFilters = Array.from(this.selectedCategoriesFilter, x => x.code);
        this.getExpensesByIntervalAndCategory(this.expensesStartDate,this.expensesEndDate,selectedFilters);
      }else{
        alert('Please select Start Date, End Date and Category');
      }
    },
    async fillIntervalDates(){
      await this.setEndDate();
      this.expensesStartDate = getCurrentMonthStart();
    },
    async setEndDate(){
      this.expensesEndDate = getCurrentDate();
    },
    async editItem (item) {      
      this.selectedMasterCategory = item.category.masterCategory;
      this.editedIndex = this.expenses.indexOf(item)
      this.editedItem = Object.assign({}, item)

      var selectedFilters = [];  
      selectedFilters.push(item.category);
      selectedFilters = Array.from(selectedFilters, x => x.code); 
      await this.getAssumptionsByCategory(selectedFilters, this.editedItem.expenseDate);
      this.dialog = true
    },

    async duplicateItem (item) {      
      this.selectedMasterCategory = item.category.masterCategory;
      this.editedItem = Object.assign({}, item)
      this.editedIndex = -1; 

      var selectedFilters = [];  
      selectedFilters.push(item.category);
      selectedFilters = Array.from(selectedFilters, x => x.code); 
      await this.getAssumptionsByCategory(selectedFilters, this.editedItem.expenseDate);
      this.dialog = true
    },

    deleteItem (item) {
      if(confirm('Are you sure you want to delete this item?')){
        this.deleteExpense(item);
      } 
    },

    close () {
      this.selectedMasterCategory = '';
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {

      if(!this.editedItem.expenseDate){
        alert('Expense Date cannot be empty!');
        return;
      }      
      if(!this.editedItem.bankAccount){
        alert('Bank Account cannot be empty!');
        return;
      } 
      if(!this.editedItem.category){
        alert('Category cannot be empty!');
        return;
      }     
      if(!this.editedItem.amount){
        alert('Amount cannot be empty!');
        return;
      }   
      if(!this.editedItem.currency){
        alert('Currency cannot be empty!');
        return;
      } 

      if (this.editedIndex > -1) {        
        this.updateExpense(this.editedItem);
      } else {
        this.addExpense(this.editedItem);         
      }      
    },
    addExpense(item){      
      this.showProgress = true;
      this.$axios.post(this.$apiurl + API_URL, {
        currencyId: item.currency.id,
        bankAccountId: item.bankAccount.id,
        categoryId: item.category.id,
        amount: item.amount,
        expenseDate:item.expenseDate,
        explanation: item.explanation, 
        personnelId: (item.personnel && this.editedItem.category.personnelRelated)? item.personnel.id : null,
        assumptionId: item.assumption ? item.assumption.id : null,
      })
      .then(response => {        
        if (response.status === 201) {
          this.getExpensesByInterval(this.expensesStartDate,this.expensesEndDate);
          this.$radio.$emit('success', {message:'Expense Created Successfully'});
          this.close();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateExpense(item){
      this.showProgress = true;
      let that = this;
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        currencyId: item.currency.id,
        bankAccountId: item.bankAccount.id,
        categoryId: item.category.id,
        amount: item.amount,
        expenseDate:item.expenseDate,
        explanation: item.explanation,
        personnelId: (item.personnel && this.editedItem.category.personnelRelated)? item.personnel.id : null,
        assumptionId: item.assumption ? item.assumption.id : null,
      })
      .then(response => {
        if (response.status === 200) {
          this.getExpensesByInterval(this.expensesStartDate,this.expensesEndDate);
          this.$radio.$emit('success', {message:'Expense Updated Successfully'});
          this.close();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    bankAccountSelected(item){      
      this.editedItem.currency = item.currency;
    },
    deleteExpense(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
        if (response.status === 200) {
          const index = this.expenses.indexOf(item);
          this.expenses.splice(index, 1);
          this.$radio.$emit('success', {message:'Expense Deleted Successfully'});
        }
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },    
    getExpensesByInterval(startDate, endDate){
      this.showProgress = true;
      this.$axios.get(this.$apiurl + API_URL, { 
            params: {
              startDate: startDate,
              endDate: endDate,
            }                                               
          })
          .then(response => {
            this.totalExpenseAmount = response.data.totalAmount;
            this.totalExpenseAmountUSD = response.data.totalAmountUSD;
            this.expenses = response.data.expenseList;
            this.showProgress = false;
          }) 
          .catch(error => {
              console.log(error);
          });  
    }, 
    getExpensesByIntervalAndCategory(startDate, endDate,selectedFilters){
      this.$axios.post(this.$apiurl + API_URL+"/filter/expenseCategories", {             
            startDate: startDate,
            endDate: endDate,
            categories : selectedFilters                 
          })
          .then(response => {
            this.totalExpenseAmount = response.data.totalAmount;
            this.totalExpenseAmountUSD = response.data.totalAmountUSD;
            this.expenses = response.data.expenseList;
            this.showProgress = false;
          }) 
          .catch(error => {
              console.log(error);
          });  
    },
    getMasterCategories(){     
        this.$axios.get(this.$apiurl + MASTER_CATEGORIES_API_URL)
            .then(response => {
                this.masterCategoryList = response.data;            
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getAllCategories(){     
        this.$axios.get(this.$apiurl + ALL_CATEGORIES_API_URL)
            .then(response => {
                this.allCategoryList = response.data;            
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    categorySelected(category){
      var selectedFilters = [];  
      selectedFilters.push(category);
      selectedFilters = Array.from(selectedFilters, x => x.code); 
      this.getAssumptionsByCategory(selectedFilters, this.editedItem.expenseDate);
    },
    getCategoriesByMaster(master){         
        this.$axios.get(this.$apiurl + CATEGORIES_API_URL+'/'+master)
            .then(response => {
                this.categoryList = response.data
                //this.editedItem.category = this.categoryList[0];  
            })
            .catch(error => {
                console.log(error);
            });                         
    },
    getAssumptionsByCategory(selectedFilters, expenseDate){  
        this.$axios.post(this.$apiurl + ASSUMPTIONS_API_URL, {   
            categories : selectedFilters    ,
            startDate : expenseDate  ,
            endDate : expenseDate           
          }).then(response => {
                this.budgetAssumptions = response.data;
            })
            .catch(error => {
                console.log(error);
            });                         
    },
    getCurrencies(){     
        this.$axios.get(this.$apiurl + CURRENCIES_API_URL)
            .then(response => {
                this.currencyList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getBankAccounts(){     
        this.$axios.get(this.$apiurl + BANK_ACCOUNTS_API_URL)
            .then(response => {
                this.bankAccountList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getPersonnels(){     
      this.$axios.get(this.$apiurl + PERSONNEL_API_URL)
          .then(response => {
              this.personnels = response.data
          }) 
          .catch(error => {
              console.log(error);
          });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
